import React from "react";
import { Phone, CalendarHeart, ShieldCheck } from "lucide-react";

const HillcrestLogo = () => (
  <a href="#top" className="flex flex-col items-center select-none" data-testid="hc-logo">
    <div className="hc-logo-text text-2xl md:text-[28px] leading-none">HILLCREST</div>
    <div className="hc-logo-tagline text-[9px] md:text-[10px] mt-1.5">
      ASSISTED LIVING
    </div>
    <div className="hc-logo-tagline text-[9px] md:text-[10px] mt-0.5">
      SAN AUGUSTINE, TX
    </div>
    <div className="mt-2 h-[1.5px] w-full bg-gradient-to-r from-[#2d7a4f] via-[#2974a3] to-[#2563a8]" />
  </a>
);

const Header = () => {
  const nav = [
    { label: "About", href: "#about" },
    { label: "Our Care", href: "#amenities" },
    { label: "Director", href: "#director" },
    { label: "Gallery", href: "#gallery" },
    { label: "Stories", href: "#testimonials" },
    { label: "Volunteer", href: "#volunteer" },
    { label: "Contact", href: "#tour" },
  ];

  return (
    <header className="hc-header sticky top-0 z-50" data-testid="site-header">
      <div className="container-hc py-4 flex items-center justify-between gap-6">
        <HillcrestLogo />

        <nav className="hidden lg:flex items-center gap-7 text-[14px] font-medium text-[color:var(--hc-navy)]/80">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="hover:text-[color:var(--hc-coral)] transition-colors"
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="tel:9362750222"
            className="hidden md:inline-flex items-center gap-2 text-sm font-semibold text-[color:var(--hc-navy)] hover:text-[color:var(--hc-coral)] transition-colors"
            data-testid="header-call"
          >
            <Phone size={16} />
            (936) 275-0222
          </a>
          <a
            href="#tour"
            className="inline-flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full bg-[#2d7a4f] text-white text-sm font-semibold shadow-[0_6px_18px_rgba(45,122,79,0.32)] hover:bg-[#246340] transition-all hover:-translate-y-0.5"
            data-testid="header-schedule-tour"
          >
            <CalendarHeart size={16} />
            Virtual Tour
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
